// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Y6R2","amount":"Amount_amount__pNw6f","tip":"Amount_tip__cJP4B","tipHeader":"Amount_tipHeader__2nLzd","tipsWrap":"Amount_tipsWrap__1AdE8"};